export const rsaPublicKey = `-----BEGIN public key-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC3yWkNvyIYZMLLm4BJdt7DaD/3
kxPXkjuvPcsd8aVeoRb4RIFEUZhXCbppEuhGAAgJoaZtMaFEn9pSByQ8V7AaOIZT
qDlSus8R1yXOMsotYG7bTgLbaPMB1wGgrn95woNZzZP9tYZ84oBi8Nm5pofEhZ/W
ImT1HOLVP5EtGG6lbwIDAQAB
-----END public key-----`

export const rsaPrivatekey = `-----BEGIN private key-----

-----END private key-----`

// 验证码类型，目前除了0是短信，其他都是语音
export const CODE_TYPE = {
  SMS: 0, // 短信
  VOICE: 1, // 语音
}

// 图片上传类型，后端需要对图片上传接口进行精细化管理
export const IMAGE_UPLOAD_TYPE = {
  NAME_IDENTITY: 1, // 实名认证
  ADMIT_APPEAL: 2, // 司机准入
}
